module.exports = "<div appHasRight=\"VIEW\" ScreenCode=\"MAP_COMP\">\r\n  <h1>Map Works</h1>\r\n</div>"